import { Component, forwardRef } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { UserActionBaseComponent } from '../userAction-base.component';
import { Customer } from '../../../../Model/User/Customer';
import { UpdateTemplate } from '../../../../Model/Catalog/UpdateTemplate';
import { TranslateService } from '@ngx-translate/core';
import { FieldNames } from '../../../../Model/FieldNames';
import { Message } from '../../../../Model/System/Message';
import { SystemService } from '../../../../Services/system.service';
import { Catalog } from '../../../../Model/Catalog/Catalog';
import { TranslatedText } from '../../../../Model/ui/TranslatedText';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { Router } from '@angular/router';
import { UpdateTemplateService } from 'app/Services/updateTemplate.service';

@Component({
    selector: 'userAction-updateToCatalog',
    templateUrl: 'userAction-updateToCatalog.component.html',
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionUpdateToCatalogComponent) }
    ],
    standalone: false
})
export class UserActionUpdateToCatalogComponent extends UserActionBaseComponent {
  private fieldNames: FieldNames;
  _catalogs: Catalog[];
  _customers: Customer[];
  _replacePrice: boolean = false;
  _selectedCustomer: string;
  _sourceCatalog: string = '';
  selectedCatalogs: string[];
  updateTemplates: UpdateTemplate[];
  selectedTemplate: string = '';
  txtSelectTemplate: string;
  txtSelectCatalog: string;
  useEanAsKey: boolean = false;
  loading: boolean = false;
  keys: TranslatedText[] = [];
  selectedKey: string;
  selectedExportParameterId: string = '';

  warningSpidUpdate: string = '';
  warningIntPidUpdate: string = '';
  warningSpaltidUpdate: string = '';

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService,
    public systemService: SystemService,
    public router: Router,
    public updateTemplateService: UpdateTemplateService
  ) {
    super(loginService, macroService);
    // merken:
    this.currentNavigationTitle = this.systemService.currentNavigationTitle;

    this.fieldNames = new FieldNames();

    this.warningSpidUpdate = this.translate.instant('warningSpidUpdate');
    this.warningIntPidUpdate = this.translate.instant('warningIntPidUpdate');
    this.warningSpaltidUpdate = this.translate.instant('warningSpaltidUpdate');

    this.keys.push(new TranslatedText('SUPPLIER_PID', this.translate.instant('SUPPLIER_PID')));
    this.keys.push(new TranslatedText('INTERNATIONAL_PID', this.translate.instant('INTERNATIONAL_PID')));
    this.keys.push(new TranslatedText('SUPPLIER_ALT_PID', this.translate.instant('SUPPLIER_ALT_PID')));
    this.selectedKey = this.keys[0].value;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.txtSelectTemplate = this.translate.instant('Bitte wählen Sie ein Update-Template aus');
    this.txtSelectCatalog = this.translate.instant('Bitte wählen Sie mindestens einen Katalog aus');

    this.loginService.customerService
      .getAllCustomerByUser(this.loginService.currentUser.id)
      .subscribe((customers: Customer[]) => {
        this.customers = customers;
        this.selectedCustomer = this.loginService.currentCustomer.id;
      });

    this.updateTemplateService.getUpdateTemplates().subscribe((templates: UpdateTemplate[]) => {
      this.updateTemplates = templates;
    });

    // der CTOR von updateTemplates ändert ihn, wir müssen den wieder zurücksetzen:
    this.systemService.currentNavigationTitle = this.currentNavigationTitle;
  }

  currentNavigationTitle: string = '';

  _showPopup: boolean = false;

  get showPopup() {
    return this._showPopup;
  }

  set showPopup(value: boolean) {
    this._showPopup = value;

    if (value) {
      // reicht in ngOnInit:
      // der CTOR von updateTemplates ändert ihn, wir müssen den wieder zurücksetzen:
      //this.modelService.systemService.currentNavigationTitle = this.currentNavigationTitle;
    } else {
      // nach dem Schließen des Popup die Liste neu laden, falls ein neues Template angelegt wurde:
      this.updateTemplateService.getUpdateTemplates().subscribe((templates: UpdateTemplate[]) => {
        this.updateTemplates = templates;
        if (templates.length > 0 && this.selectedTemplate == '') {
          this.selectedTemplate = templates[0].id;

          this.onKeyChanged(null);
        }
      });
    }
  }

  showEditTemplates() {
    this.showPopup = true;
  }

  editTemplatesClick() {
    this.router.navigate(['updateTemplates']);
  }

  get catalogs(): Catalog[] {
    return this._catalogs;
  }

  set catalogs(value: Catalog[]) {
    this._catalogs = value;
  }

  get customers(): Customer[] {
    return this._customers;
  }

  set customers(value: Customer[]) {
    this._customers = value;
  }

  get replacePrice(): boolean {
    return this._replacePrice;
  }

  set replacePrice(value: boolean) {
    this._replacePrice = value;
  }

  get selectedCustomer(): string {
    return this._selectedCustomer;
  }

  set selectedCustomer(value: string) {
    this._selectedCustomer = value;
    this.catalogService.getCatalogs(this._selectedCustomer).subscribe((result: Catalog[]) => {
      this.catalogs = result.filter((c) => !c.isVirtual);
    });
  }

  get sourceCatalog(): string {
    return this._sourceCatalog;
  }

  set sourceCatalog(sourceCatalog: string) {
    this._sourceCatalog = sourceCatalog;
  }

  onKeyChanged($event) {
    let template = this.updateTemplates.filter((u) => u.id == this.selectedTemplate)[0];
    if (template == null || template == undefined) {
      return;
    }
  }

  clickSelectValidCatalogs() {
    this.loading = true;
    switch (this.selectedKey) {
      case this.keys[0].value:
        this.catalogService
          .getCatalogsContainingSupplierPID(
            this.catalogService.catalog.id,
            this.loginService.currentCustomer.id,
            this._selectedCustomer
          )
          .subscribe((result: string[]) => {
            this.selectedCatalogs = result;
            this.loading = false;
          });
        break;
      case this.keys[1].value:
        this.catalogService
          .getCatalogsContainingEAN(
            this.catalogService.catalog.id,
            this.loginService.currentCustomer.id,
            this._selectedCustomer
          )
          .subscribe((result: string[]) => {
            this.selectedCatalogs = result;
            this.loading = false;
          });
        break;
      case this.keys[2].value:
        this.catalogService
          .getCatalogsContainingSupplierAltPID(
            this.catalogService.catalog.id,
            this.loginService.currentCustomer.id,
            this._selectedCustomer
          )
          .subscribe((result: string[]) => {
            this.selectedCatalogs = result;
            this.loading = false;
          });
        break;
    }
  }

  createParameterStringAsJsonString() {
    return JSON.stringify({
      targetCatalogId: this.sourceCatalog,
      targetCustomerId: this.selectedCustomer,
      sourceCatalogId: this.catalogService.catalog?.id,
      sourceCustomerId: this.loginService.currentCustomer.id,
      updateTemplateId: this.selectedTemplate,
      productKey: this.selectedKey,
      exportParameterId: this.selectedExportParameterId,
      selectedCatalogs: this.selectedCatalogs

    });
  }

  public async canStartMacro() : Promise<boolean>{
    if (this.selectedCatalogs.length == 0) {
      this.systemService.notifyInfo(this.txtSelectCatalog);
      return false;
    }

    if (this.selectedTemplate == '') {
      this.systemService.notifyInfo(this.txtSelectTemplate);
      return false;
    }

    return true;
  }

  parseParameter(parameter: string) {
    if(!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.sourceCatalog = parsed.targetCatalogId;
      this.selectedCustomer = parsed.targetCustomerId;
      this.loginService.currentCustomer.id = parsed.sourceCustomerId;
      this.selectedTemplate = parsed.updateTemplateId;
      this.selectedKey = parsed.productKey;
      this.selectedExportParameterId = parsed.exportParameterId;
      this.selectedCatalogs = parsed.selectedCatalogs;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }

  get referenceCatalogId(): string{
    if(this.selectedCatalogs && this.selectedCatalogs.length >= 1)
      return this.selectedCatalogs[0];
  }
}
